import React from 'react';
import { Box, Typography, Textarea } from '@mui/joy';

interface MeetingNotesInputProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const MeetingNotesInput: React.FC<MeetingNotesInputProps> = ({ value, onChange }) => (
  <Box mb={2}>
    <Typography level="body-sm" mb={1}>Meeting Notes (optional)</Typography>
    <Textarea
      minRows={3}
      value={value}
      onChange={onChange}
      placeholder="Add any notes for this meeting (optional)"
      sx={{
        width: '100%',
        borderRadius: 12,
        backgroundColor: '#edeff3',
        border: 'none',
        fontSize: 16,
        pl: 2,
        pr: 2,
        boxShadow: 'none',
        '& textarea': { backgroundColor: 'transparent' },
      }}
    />
  </Box>
);

export default MeetingNotesInput; 